import type { ReactNode } from "react";

const BR_TAG = /<br\s*\/?>/gi;

function brTagsToNewlines(text: string): string {
  return text.replace(BR_TAG, "\n");
}

/** Renders plain text with newline and `<br>` breaks as `<br />` elements. */
export function renderTextWithLineBreaks(text: string): ReactNode {
  const lines = brTagsToNewlines(text).split("\n");
  return lines.map((line, index) => (
    <span key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </span>
  ));
}
